import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a7ee8ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "row justify-content-center asahi-tabs-container-cta" }
const _hoisted_7 = {
  key: 0,
  class: "fw-bold d-flex justify-content-center mb-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiButton = _resolveComponent("AsahiButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: _normalizeClass(_ctx.isMobile ? 'col-6': 'col-3')
        }, [
          (index < 4)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["asahi-search-results-item cursor-pointer", {'mt-3': _ctx.isMobile}]),
                onClick: ($event: any) => (_ctx.navigateToProductPage(item))
              }, [
                _createElementVNode("div", {
                  class: "asahi-search-results-item-img",
                  style: _normalizeStyle({ backgroundImage: 'url(' + item.small_image.url + ')' })
                }, null, 4),
                _createElementVNode("p", null, [
                  _createElementVNode("span", {
                    innerHTML: item.catalog_product_name.replace(RegExp('(' + _ctx.searchType + ')', 'gi'), '<b>$1</b>')
                  }, null, 8, _hoisted_3)
                ]),
                (!_ctx.isMobile)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                      _createTextVNode(_toDisplayString(_ctx.isOnTradeCustomer ? _ctx.$t('Price') : _ctx.$t('Unit price w/o VAT')) + " ", 1),
                      _createElementVNode("b", null, _toDisplayString(_ctx.isOnTradeCustomer ? _ctx.formatCurrency(item.your_price) : _ctx.formatCurrency(item.your_price_tax)), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_5, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.isOnTradeCustomer ? _ctx.formatCurrency(item.your_price) : _ctx.formatCurrency(item.your_price_tax)), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.isOnTradeCustomer ? _ctx.$t('Price') : _ctx.$t('w/o VAT')), 1)
                    ]))
              ], 10, _hoisted_2))
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.products.length <= 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('No Result Found')), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["col-auto", {'mt-4': _ctx.isMobile}])
      }, [
        _createVNode(_component_router_link, { to: "/catalog/products" }, {
          default: _withCtx(() => [
            _createVNode(_component_AsahiButton, {
              type: "secondary",
              onClick: _ctx.navigateToProducts
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('All results in this section')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ], 2)
    ])
  ], 64))
}